import {Message} from 'element-ui';
import {getMessageList, getUnReadNoticeList} from '@/api/base';

// 打开弹层保存的数据变量
const state = {
  emitName: 'dialogChangeCall',
  activeName: '',
  orderId: '',
  orderExtractParams: {},
  bussinessId: '',
  bussinessExtractParams: {},
  userId: '',
  userExtractParams: {},
  // 左侧导航栏待处理消息数量
  approveList: {},
  approveTotal: 0,
  // 顶部导航栏未读消息数量
  msgList: [],
  msgTotal: 0,
  // 未读公告消息列表
  noticeList: []
}

const mutations = {
  SETORDERINFO (state, {orderId, extract}) {
    state.orderId = orderId;
    state.orderExtractParams = {...extract};
  },
  SETBUSSINESSINFO (state, {bussinessId, extract}) {
    state.bussinessId = bussinessId;
    state.bussinessExtractParams = {...extract};
  },
  SETUSERINFO (state, {userId, extract}) {
    state.userId = userId;
    state.userExtractParams = {...extract};
  },
  SETACTIVENAME (state, name) {
    state.activeName = name;
  },
  SETAPPROVELIST (state, list) {
    state.approveList = list;
  },
  SETAPPROVETOTAL (state, total) {
    state.approveTotal = total;
  },
  SETMSGLIST (state, list) {
    state.msgList = list;
  },
  SETMSGTOTAL (state, total) {
    state.msgTotal = total;
  },
  SETNOTICELIST (state, list) {
    state.noticeList = list;
  }
}

let timeOut = null;
let noticeTimeOut = null;
const actions = {
  // 请求当前用户需要审批的数量
  initCurrentUserApprove ({dispatch, rootState}) {
    if (!rootState.user.token) return null;
    if (timeOut) {
      clearTimeout(timeOut);
      timeOut = null;
    }
    dispatch('getCurrentUserApprove');
    timeOut = setTimeout(() => {
      timeOut = null;
      dispatch('initCurrentUserApprove');
    }, 1 * 60 * 1000)
  },
  async getCurrentUserApprove ({commit}) {
    try {
      const res = await getApproveTotal();
      let total = 0;
      let items = {};
      if (res && res.length > 0) {
        res.map(v => {
          total += v.total;
          items[v.voucher_type] = v.total;
        });
      }
      commit('SETAPPROVELIST', items);
      commit('SETAPPROVETOTAL', total);
    } catch (error) {
      console.log('获取用户审批数量错误：', error);
    }
  },
  async initMsgList ({commit}) {
    try {
      const res = await getMessageList({
        page: 1,
        per_page: 5
      });
      commit('SETMSGTOTAL', res.unread_total || 0);
      commit('SETMSGLIST', res.data || []);
    } catch (error) {
      Message.error(error.msg || '操作失败，请重试');
    }
  },
  // 请求公告列表
  initNoticeList ({dispatch, rootState}) {
    if (!rootState.user.token) return null;
    if (noticeTimeOut) {
      clearTimeout(noticeTimeOut);
      noticeTimeOut = null;
    }
    dispatch('getNoticeList');
    noticeTimeOut = setTimeout(() => {
      noticeTimeOut = null;
      dispatch('initNoticeList');
    }, 1 * 60 * 1000)
  },
  async getNoticeList ({commit}) {
    try {
      const list = await getUnReadNoticeList();
      commit('SETNOTICELIST', list['data']);
    } catch (error) {
      Message.error(error.msg || '操作失败，请重试');
    }
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}